// extracted by mini-css-extract-plugin
export var closeButton = "_po-2";
export var closeButtonIcon = "_po-3";
export var lightboxContent = "_po-1";
export var lightboxOverlay = "_po-0";